import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy} from '@angular/router';

/** NoReuseStrategy: A routing strategy that forces Angular to recreate components
 *                   on the private data enclave routes. */
@Injectable({providedIn: 'root'})
export class NoReuseStrategy implements RouteReuseStrategy {
  shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(_route: ActivatedRouteSnapshot, _handle: DetachedRouteHandle | null): void {
    // Intentionally not storing anything anywhere.
  }

  shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  // IF routing to the PDE, re-run the constructor every time (to update the signals)
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (
      future.routeConfig?.path?.startsWith('private-data-enclave') ||
      curr.routeConfig?.path?.startsWith('private-data-enclave')
    ) {
      return false;
    }
    return future.routeConfig === curr.routeConfig;
  }
}
